// Generated by scripts/mdi/import-questionnaires.mjs from MDI "MOTS-C 3.20.26 09.17.26" (d00f8c90-b2cd-4416-96b6-eebad2d28412). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiMOTSCQuestions = [
  {
    field: 'mdiMOTSC_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiMOTSC_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiMOTSC_wereSorryBasedPreviousAnswer',
    label:
      "We're sorry, based on a previous answer, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '26bf344e-e26a-4f70-bd4e-135fea0eec75',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiMOTSC_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1YPxj32dGcTv_Yr3Ao8X82FTdC0uFIjVJ/view)',
    answer: {
      type: 'text',
      name: 'mdiMOTSC_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '568285cb-02e3-4b24-9e97-cd6a73be8b3c' }
  },
  {
    field: 'mdiMOTSC_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'enhanced_insulin_sensitivity_and_improve',
          value: 'Enhanced insulin sensitivity and improved glucose metabolism'
        },
        {
          key: 'increased_fat_oxidation_and_metabolic_ef',
          value: 'Increased fat oxidation and metabolic efficiency'
        },
        {
          key: 'improved_exercise_capacity_and_endurance',
          value:
            'Improved exercise capacity and endurance (exercise-mimetic effects)'
        },
        {
          key: 'reduced_inflammation_and_oxidative_stres',
          value: 'Reduced inflammation and oxidative stress'
        },
        {
          key: 'support_for_healthy_aging_processes',
          value: 'Support for healthy aging processes'
        },
        {
          key: 'enhanced_mitochondrial_function_and_cell',
          value:
            'Enhanced mitochondrial function and cellular energy production'
        },
        {
          key: 'bone_health_through_promotion_of_osteobl',
          value:
            'Bone health through promotion of osteoblast activity and inhibition of bone resorption'
        },
        {
          key: 'cardiovascular_health_support',
          value: 'Cardiovascular health support'
        },
        {
          key: 'potential_neuroprotective_effects',
          value: 'Potential neuroprotective effects'
        },
        {
          key: 'cellular_repair_and_tissue_regeneration',
          value: 'Cellular repair and tissue regeneration support'
        }
      ]
    },
    extras: { mdiQuestionId: '5c89adc0-484c-4967-907a-22e929933cc5' }
  },
  {
    field: 'mdiMOTSC_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'ed152585-ea0e-4b92-b14d-e5086e8a464a' }
  },
  {
    field: 'mdiMOTSC_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: { type: 'text', name: 'mdiMOTSC_peptidesUsedPreviously', rows: 4 },
    extras: { mdiQuestionId: 'adf14ef0-bc09-4d9c-8747-d346b94a7f4a' }
  },
  {
    field: 'mdiMOTSC_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '7b9d372c-81e9-405d-b1ed-8d3cad1dfbc7' }
  },
  {
    field: 'mdiMOTSC_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: { type: 'text', name: 'mdiMOTSC_reactionSideEffect', rows: 4 },
    extras: { mdiQuestionId: '2b00d942-1acb-4690-be5b-e37b0f233b78' }
  },
  {
    field: 'mdiMOTSC_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_like_heart_attack',
          value: 'Cardiovascular disease like heart attack, stroke, etc'
        },
        { key: 'diabetes', value: 'Diabetes' },
        { key: 'autoimmune_disease', value: 'Autoimmune disease' },
        { key: 'immunodeficiency', value: 'Immunodeficiency' },
        { key: 'high_blood_pressure', value: 'High blood pressure' },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'organ_transplant', value: 'Organ transplant' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '32ad00ec-e0d6-4eff-b812-29201787717e' }
  },
  {
    field: 'mdiMOTSC_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: '2db4e650-efe6-4d8c-904a-66a8f6cc6f28' }
  },
  {
    field: 'mdiMOTSC_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'metformin', value: 'Metformin' },
        { key: 'berberine', value: 'Berberine' },
        { key: 'glp1_gip_agonists', value: 'GLP1/GIP agonists' },
        { key: 'sglt2_inhibitor', value: 'SGLT2 inhibitor' },
        { key: 'resveratrol', value: 'Resveratrol' },
        {
          key: 'nad_supplements_or_precursors',
          value: 'NAD supplements or precursors'
        },
        { key: 'insulin', value: 'Insulin' },
        { key: 'antiviral_medication', value: 'Antiviral medication' },
        {
          key: 'chemotherapy_or_oncology_treatments',
          value: 'Chemotherapy or oncology treatments'
        },
        { key: 'alcohol_use', value: 'Alcohol use' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'd219d763-7a82-4722-900e-f01c6636abba' }
  },
  {
    field: 'mdiMOTSC_manyAlcoholicDrinksConsumePer',
    label: 'How many alcoholic drinks do you consume per week?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'o_1_3_drinks', value: '1-3 drinks' },
        { key: 'o_3_6_drinks', value: '3-6 drinks' },
        { key: 'o_6_9_drinks', value: '6-9 drinks' },
        { key: 'o_10_or_more_drinks', value: '10 or more drinks' }
      ]
    },
    extras: { mdiQuestionId: 'a1df8142-caad-4dc6-999b-850d35fe5cfd' }
  },
  {
    field: 'mdiMOTSC_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'b9af0706-e271-423a-9256-fade8a706524' }
  },
  {
    field: 'mdiMOTSC_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '51a65c12-b547-4e14-92d9-56f594eeecfd' }
  },
  {
    field: 'mdiMOTSC_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiMOTSC_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '9c701041-d86e-46e2-bc9a-4ca65923c251' }
  },
  {
    field: 'mdiMOTSC_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: { type: 'text', name: 'mdiMOTSC_firstMessageDoctor', rows: 4 },
    extras: { mdiQuestionId: 'e6aa44fe-d8e2-4076-93ca-3c313809247c' }
  },
  {
    field: 'mdiMOTSC_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiMOTSCAnswerField = Partial<
  QuestionAnswerMap<typeof mdiMOTSCQuestions>
>;

export default mdiMOTSCQuestions;
